import { Brand } from 'effect'
import { z } from 'zod'

export type RaceRowDTO = {
  created_at: string
  id: string
  round: number
  race_configuration_id: string
  is_lightning_round?: boolean
  lightning_boost_type?: string | null
  lightning_boost_percent?: number | null
  lightning_boosted_items?: string[] | null
} & Brand.Brand<'RaceRowDTO'>

export const RaceRowDTORawSchema = z.object({
  created_at: z.string(),
  id: z.string(),
  round: z.number(),
  race_configuration_id: z.string(),
  is_lightning_round: z.boolean().optional(),
  lightning_boost_type: z.string().nullable().optional(),
  lightning_boost_percent: z.number().nullable().optional(),
  lightning_boosted_items: z.array(z.string()).nullable().optional()
})

export const brandToRaceRowDTO = Brand.nominal<RaceRowDTO>()

export const RaceRowDTOSchema = RaceRowDTORawSchema.transform(brandToRaceRowDTO)
